import React from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import { SecondaryActionButton } from '../SecondaryActionButton';
import { StyledModal } from './StyledModal';

const Button = SecondaryActionButton(StyledModal);

export const DownloadAnywayButton = ({
    modalStep,
    onClick,
}: {
    modalStep: number;
    onClick: () => Promise<void>;
}) => {
    if (modalStep !== 1) {
        return null;
    }

    return (
        <Button
            appearance="subtle"
            label={_('Download anyway')}
            onClick={onClick}
        />
    );
};
